<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-5">
      <div class="card">
        <div class="card-body text-center vstack gap-3 p-4">
          <h3 class="fw-bold">Signing you in...</h3>
          <p *ngIf="error === null" class="text-muted mb-0">
            Your account is ready.
          </p>
          <div *ngIf="error !== null" class="alert alert-warning mb-0" role="alert">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>